import { render, staticRenderFns } from "./createStockLnventoryPlan.vue?vue&type=template&id=b2f2c6b0&scoped=true"
import script from "./createStockLnventoryPlan.vue?vue&type=script&lang=js"
export * from "./createStockLnventoryPlan.vue?vue&type=script&lang=js"
import style0 from "./createStockLnventoryPlan.vue?vue&type=style&index=0&id=b2f2c6b0&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b2f2c6b0",
  null
  
)

export default component.exports